import React from 'react';
import { Form } from 'react-final-form';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { testWindow } from '../Wrappers/MainWindow';
import edit from '../../svg/edit.svg';
import Frame from '../Wrappers/Frame';
import WorkingHours from './WorkingHours';
import { updateInfo } from '../../redux/business';
import ProfileMedia from './ProfileMedia';
import { FieldWithError } from '../Offers/Create/FormAdapters';
import { pick } from '../../helpers';
import { FormLabel, Line, ProfileSaveButton } from '../Common';
import { Row, Col } from '../Grid';
import { AnalyticsService } from '../../services/AnalyticsService';

interface Props {
  save: Function;
  business: any;
  edit: boolean;
  openEdit: Function;
  closeEdit: Function;
}

interface State {
  editing: boolean;
  showImageForm: boolean;
}

const InputText = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 14px;
  margin-bottom: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0.3px;
  color: var(--color-gunmetal);
`;

const inputStyle = {
  width: 'inherit',
  marginBottom: '20px',
  color: '#555555',
  borderRadius: '2px',
  border: 'solid 1px #eeeeee',
  marginTop: '2px',
  marginRight: '50px',
};

const Label = styled(FormLabel)`
  font-family: BrandonGrotesque-Medium;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.17;
  letter-spacing: 0.6px;
  color: var(--color-greyish-brown);
`;

class Profile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { editing: props.edit, showImageForm: false };
  }

  save(data) {
    this.props.save(data);
    this.props.closeEdit();
  }

  generateField(name: string, title: string, editable = true) {
    return (
      <>
        <Label>{title}</Label>
        {this.state.editing && editable ? (
          <FieldWithError style={inputStyle} name={name} autoComplete="on" component={'input'} />
        ) : (
          <InputText>{this.props.business[name]}</InputText>
        )}
      </>
    );
  }

  render() {
    document.title = (this.state.editing ? 'Edit ' : '') + 'Profile • Neoncoat Brands Tool';
    const initial = pick(this.props.business, [
      'email',
      'contact_email',
      'contact_name',
      'description',
      'website',
      'phone_number',
    ]);

    return (
      <Form
        onSubmit={(state) => this.save(state)}
        initialValues={initial}
        render={({ handleSubmit }) => (
          <Row>
            <Col size="9">
              <Frame
                title="Brand Profile"
                right={
                  this.state.editing ? (
                    <ProfileSaveButton
                      onClick={() => {
                        handleSubmit();
                        AnalyticsService.track('Tap Save Profile', {});
                      }}
                    >
                      SAVE
                    </ProfileSaveButton>
                  ) : (
                    <img
                      src={edit}
                      alt="Save"
                      style={{ paddingRight: '10px', cursor: 'pointer' }}
                      onClick={() => {
                        AnalyticsService.track('Tap Edit Profile', {});
                        this.props.openEdit();
                      }}
                    />
                  )
                }
              >
                <Row>
                  <Col size="1" style={{ paddingRight: '10px' }}>
                    {this.generateField('name', 'BRAND', false)}
                    {this.generateField('email', 'ACCOUNT EMAIL', false)}
                    {this.generateField('contact_name', 'CONTACT')}
                    {this.generateField('contact_email', 'CONTACT EMAIL')}
                    {this.generateField('phone_number', 'PHONE')}
                  </Col>

                  <Col size="1">
                    <Label>LOCATION</Label>
                    <InputText>{this.props.business.location.address}</InputText>
                    <Label>ABOUT YOUR BRAND</Label>
                    {this.state.editing ? (
                      <>
                        <FieldWithError
                          style={inputStyle}
                          name="description"
                          placeholder="Let the models know what you’re offering."
                          rows={4}
                          component="textarea"
                        />
                      </>
                    ) : (
                      <InputText>{this.props.business.description}</InputText>
                    )}

                    {this.generateField('website', 'WEBSITE')}
                  </Col>
                </Row>

                <Line style={{ marginTop: '30px' }} />
              </Frame>

              <ProfileMedia items={this.props.business.media} />

              <WorkingHours />
            </Col>
            <Col size="3" />
          </Row>
        )}
      />
    );
  }
}

const mapStateToProps = ({ business }: StoreState) => ({ business });

const mapDispatchToProps = {
  save: (data: any) => updateInfo(data),
  openEdit: () => push('/profile/edit'),
  closeEdit: () => push('/profile'),
};

export default connect(mapStateToProps, mapDispatchToProps)(testWindow(Profile, 'profile'));
